<template>
    <div style="overflow-x:hidden">
        <BannerStatic :ban="wWidth<768?banner[1]:banner[0]"></BannerStatic>
        <Products></Products>
    </div>
</template>

<script>
import BannerStatic from '@/components/header/bannerStatic.vue'
import Products from '@/components/products/products.vue'

export default {
    components:{
        BannerStatic,
        Products
    },
    data(){
        return{
          banner: [require('../assets/bannerVR.jpg'),require('../assets/phone/bannerVR.png')],
          wWidth: window.screen.width
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep {
    .eyBc{
      .el-breadcrumb{
        span{
          &:nth-child(3){
            i{
              display: none;
            }

            .el-breadcrumb__inner a:hover, .el-breadcrumb__inner.is-link:hover{
              cursor: default;
              color: black;
            }
            
          }
        }//span
      }//.el-breadcrumb

    }//.eyBc
}
</style>